module.exports = __webpack_public_path__ + "img/UNION.png?cf5f37ac4dce0f782e5f8d6992dddc17";